// extracted by mini-css-extract-plugin
module.exports = {"item":"c3X7v","active":"-aLtg","label":"_2JGPj","rightChevron":"QMOts","icon":"_2g8bW"};